import { render, staticRenderFns } from "./TfacTab.vue?vue&type=template&id=ca5c95f6"
import script from "./TfacTab.vue?vue&type=script&lang=js"
export * from "./TfacTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports